// @ts-nocheck
import {useQuery} from "@tanstack/react-query";
import {listRecentGamesService} from "../../services/games/miniGames/recentGames.service";
import {useAuthStore} from "../../store/useAuth.store";

const useListRecentGames = () => {
  const authStatus = useAuthStore(state => state.authStatus);

  const {data, isSuccess, isLoading, isError, error} = useQuery({
    queryKey: ["listRecentGames"],
    queryFn: listRecentGamesService,
    staleTime: 300,
    // Only execute the query if the user is authenticated
    enabled: authStatus === "authenticated",
  });

  return {listRecentGames: data?.data?.data, isSuccess, isError, error, isLoading};
};

export default useListRecentGames;
